
import $ from 'jquery';

export default function slateSwatch() {
	// var alreadyInit = false
	
	$(function($) {
		//Inital init
		var $swatchContainer = $('.c-swatch__color');
		var $swatchImageThumbnailContain = $('.c-swatch__imageThumbnail');
		var $label = $('.c-pdp__labelDyanmically');
		// var currentSlideIndex;
		var limitedSlideLength;
		// var $swatchImageThumbnailContainMobile = $('.c-swatch__imageThumbnail--mobile');

		if($swatchContainer.length) {

			var allProductTags = $swatchContainer.data('product-tags'),
			productHandle = $swatchContainer.data('product-handle'),
			swatchesTemplateUrl = $swatchContainer.data('swatch-url-template'),
			currentColorTag = $swatchContainer.data('product-color'),
			productTag = '';

			// Find the product tag and color tag for current product
			allProductTags.forEach(function(item) {
				if(productHandle.match(new RegExp('^' + item, 'i')) && item.length > productTag.length) {
					productTag = item;
				}
			});

			// Abort when the product tag is not found
			if(!productTag) {
				return
			}

			// Using the product tag to find out all color variants as products in Shopify
			$.get('/collections/all/' + productTag + '?view=swatch').done(function(data) {
				var productArray = JSON.parse(data);
				productArray.forEach(function(product, index) { 
					if(product.color) {
						var swatchName = product.color;
						var swatchTitle = product.color_title;
			
						var url = swatchesTemplateUrl.replace('__COLOR__', swatchName);
						//Resize Url
						var resizedUrl = slate.Image.getSizedImageUrl(url, '40x40');

						// Compose the swatch element
						var swatch = $('<a class="swatch-image ' + swatchTitle  + ' " title="' + swatchTitle + '"><img/></a>').attr('href', product.url)
							.find('img').attr('src', resizedUrl).end();
						var swatchImageThumbnail = $('<a class="swatch-image-thumbnail" title="' + swatchTitle + '"><img/></a>').attr('href', product.url)
							.find('img').attr('src', product.thumbnail_image).attr("class", 'swatchImageThumbnail__img').attr('loading', 'lazy').end();

						if(currentColorTag === swatchName) {
							var currentColor = `Color: <strong>${swatchTitle}</strong>`
							swatch.addClass('is-active');
							swatchImageThumbnail.addClass('is-active')
							$label.append(currentColor)
							// Use when slider hit the last 2, because when it hits the last 2 slides in sliders, the prev and next buttons functionality lost
							// if(productArray.length >= 4){
							// 	limitedSlideLength = productArray.length - 4
							// 	if(index >= limitedSlideLength){
							// 		currentSlideIndex = limitedSlideLength
							// 	} else {
							// 		currentSlideIndex = index
							// 	}
							// } else {
							// 	currentSlideIndex = index
							// }
							// console.log(currentSlideIndex)
						}

						swatch.appendTo($swatchContainer);
						swatchImageThumbnail.appendTo($swatchImageThumbnailContain)
					}
				});

				//Getting rid of slider for current test (Might need it back in the furture, so don't delete)
				// if(window.innerWidth < 768){
				// 	if(!alreadyInit){
				// 		$('.c-swatch__imageThumbnail').addClass('c-swatch__imageThumbnail--mobile')
				// 		$('.c-swatch__imageThumbnail--mobile').on('init', function(){
				// 			if(currentSlideIndex === 0){
				// 				$('.c-swatches__arrowLeft').addClass('c-swatches__arrowHidden')
				// 			} else if(currentSlideIndex >= limitedSlideLength + 1){
				// 				$('.c-swatches__arrowRight').addClass('c-swatches__arrowHidden')	
				// 			}
				// 		});

				// 		alreadyInit = true
				// 	}
				// } else {
				// 	if(alreadyInit){
				// 		$('.c-swatch__imageThumbnail').removeClass('c-swatch__imageThumbnail--mobile')
		
				// 		alreadyInit = false
				// 	}
				// }

				//Load after

				// window.addEventListener('resize', () => {
				// 	if(window.innerWidth < 768){
				// 		if(!alreadyInit){
				// 			$('.c-swatch__imageThumbnail').addClass('c-swatch__imageThumbnail--mobile')
				// 			$('.c-swatch__imageThumbnail--mobile').on('init', function(){
				// 				if(currentSlideIndex === 0){
				// 					$('.c-swatches__arrowLeft').addClass('c-swatches__arrowHidden')
				// 				} else if(currentSlideIndex >= limitedSlideLength + 1){
				// 					$('.c-swatches__arrowRight').addClass('c-swatches__arrowHidden')	
				// 				}
				// 			});

				// 			alreadyInit = true
				// 		}
				// 	} else {
				// 		if(alreadyInit){
				// 			$('.c-swatch__imageThumbnail').removeClass('c-swatch__imageThumbnail--mobile')
		
				// 			alreadyInit = false
				// 		}
				// 	}
				// })
			});
		}
	});
}